// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__21LwK","consentsList":"PatientConsents_consentsList__3VkaO","consentsListEmpty":"PatientConsents_consentsListEmpty__WXpbC"};